var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    y: 0.820312,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#E6F8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.06878,
    y: 1.2221,
    width: 43.1964,
    height: 43.1964,
    rx: 21.5982,
    stroke: "#09B81D",
    strokeOpacity: 0.1,
    strokeWidth: 0.803575
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7069 31.9419C23.7139 31.9419 21.9405 31.3761 20.3867 30.2445C18.8328 29.1129 17.735 27.652 17.0932 25.8617H13.5464V23.8349H16.6372C16.5865 23.4296 16.5656 23.054 16.5744 22.7081C16.5831 22.3622 16.6041 22.0622 16.6372 21.8082H13.5464V19.7814H17.0932C17.735 17.9911 18.8328 16.5302 20.3867 15.3986C21.9405 14.267 23.7139 13.7012 25.7069 13.7012C26.8723 13.7012 27.9745 13.9082 29.0135 14.3224C30.0526 14.7365 30.9771 15.3064 31.7871 16.0319L30.3431 17.4507C29.7182 16.9102 29.0132 16.488 28.2282 16.1839C27.4431 15.8799 26.6027 15.7279 25.7069 15.7279C24.2713 15.7279 22.9877 16.1039 21.8561 16.8558C20.7245 17.6077 19.8715 18.5829 19.2973 19.7814H25.7069V21.8082H18.6893C18.6217 22.2642 18.5964 22.6655 18.6133 23.0121C18.6302 23.3586 18.6555 23.6329 18.6893 23.8349H25.7069V25.8617H19.2973C19.8715 27.0608 20.7245 28.0364 21.8561 28.7883C22.9877 29.5402 24.2713 29.9159 25.7069 29.9152C26.602 29.9152 27.4425 29.7632 28.2282 29.4592C29.0139 29.1551 29.7188 28.7329 30.3431 28.1924L31.7871 29.6112C30.9764 30.3374 30.0516 30.9076 29.0125 31.3217C27.9735 31.7359 26.8716 31.9426 25.7069 31.9419Z",
    fill: "#09B81D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.af22419f2e3572e8826d847f6c26d6df.svg";
export { ForwardRef as ReactComponent };